import React, { useState } from 'react';
import {
    getLeadData,
} from "../../../actions/emActions";
import { connect } from "react-redux";
import "./statusQuestion.scss";
import $ from "jquery";
import ModalVideo from "react-modal-video";
const StatusQuestion = (props) => {
    const [popupCheck, setpopupCheck] = useState(1);
    const [videoLink, setvideoLink] = useState('');
    const [influenceImage, setinfluenceImage] = useState('');
    const [videoTitle, setvideoTitle] = useState('');
    const [imageTitle, setimageTitle] = useState('');
    const [videosList, setvideosList] = useState([
        {
            id: 1,
            videoId: "https://lincolnmethod.s3.amazonaws.com/testimonial/Helped+where+schools+couldn't.mp4",
            galleryImage: "VideoTestimonial3.png",
            title: "Helped where schools couldn't",
            isOpen: false
        },
        {
            id: 2,
            videoId: "https://lincolnmethod.s3.amazonaws.com/testimonial/Improve+skills+(1).mp4",
            galleryImage: "VideoTestimonial4.png",
            title: "Improve Skills",
            isOpen: false
        },
        {
            id: 3,
            videoId: "https://lincolnmethod.s3.amazonaws.com/testimonial/Skeptical+initialy.mp4",
            galleryImage: "VideoTestimonial4.png",
            title: "Skeptical initially",
            isOpen: false
        },
        {
            id: 4,
            videoId: "https://lincolnmethod.s3.amazonaws.com/testimonial/Taking+pressure+off+parents.mp4",
            galleryImage: "VideoTestimonial4.png",
            title: "Taking pressure off parents",
            isOpen: false
        },
        {
            id: 5,
            videoId: "https://lincolnmethod.s3.amazonaws.com/testimonial/Tracking+progress.mp4",
            galleryImage: "VideoTestimonial4.png",
            title: "Tracking progress",
            isOpen: false
        },
        {
            id: 6,
            videoId: "https://lincolnmethod.s3.amazonaws.com/testimonial/Young+%26+trained+tutors.mp4",
            galleryImage: "VideoTestimonial4.png",
            title: "Young trained tutors",
            isOpen: false
        },
        {
            id: 7,
            videoId: "https://lincolnmethod.s3.amazonaws.com/testimonial/Structured+learning+plan.mp4",
            galleryImage: "VideoTestimonial4.png",
            title: "Structured learning plan",
            isOpen: false
        },
        {
            id: 8,
            videoId: "https://lincolnmethod.s3.amazonaws.com/testimonial/Sign+up+process+is+so+easy.mp4",
            galleryImage: "VideoTestimonial4.png",
            title: "Signup process is so easy",
            isOpen: false
        },
        {
            id: 9,
            videoId: "https://lincolnmethod.s3.amazonaws.com/testimonial/Learning+independently.mp4",
            galleryImage: "VideoTestimonial4.png",
            title: "Learning independently",
            isOpen: false
        },
        {
            id: 10,
            videoId: "https://lincolnmethod.s3.amazonaws.com/testimonial/Naael+got+into+KGS.mp4",
            galleryImage: "VideoTestimonial4.png",
            title: "Naael got into KGS",
            isOpen: false
        },
        {
            id: 11,
            videoId: "https://lincolnmethod.s3.amazonaws.com/testimonial/Wasey+got+into+KGS.mp4",
            galleryImage: "VideoTestimonial4.png",
            title: "Wasey got into KGS",
            isOpen: false
        },
        {
            id: 12,
            videoId: "https://lincolnmethod.s3.amazonaws.com/testimonial/Excellent+for+my+4+y.o..mp4",
            galleryImage: "VideoTestimonial4.png",
            title: "Tutor for my 4 year old",
            isOpen: false
        }
    ]);
    const openVideoModal = (active, videoLinks, videoName) => {
        debugger;
        setvideoTitle(videoName);
        setpopupCheck(active);
        setvideoLink(videoLinks);
    }
    const openInfluenceModal = (active, img, title) => {
        debugger;
        setimageTitle(title);
        setpopupCheck(active);
        setinfluenceImage(img);
    }
    const openVideo = (id) => {
        videosList.map((item, index) => {
            if (item.id === id) {
                item.isOpen = !item.isOpen
            }
        })
        setvideosList([...videosList]);
    }
    console.log("Video link", videoLink);
    console.log("Question Data", props.initialQuestionsData);
    console.log("Fomo Pictures", props.historyData);
    const { cancelDemo, aboutThisCourse, sendParentMessage, leadId, studentId, courseId, callDontPickedUp, callPickedUp, markNoResponse, markSpammed, marknotIntrested, oneOnOneclassesImaggeSent, groupclassesImaggeSent, initialQuestionsData, onChangeInitialQuestionData, submitPersonalData, spam, notInterested, noResponse, studentName, programName, onChangeInitialQuestionDataIntrested, onChangeInitialQuestionDataChallenges, videoTestimonialSend, influenceImageSend, notConvertingQuestion, onChangeNotConvertingQuestion, curriculum_img, curriculumImageSend, submitNotConverting, sendConversionMessage, historyData } = props;
    return (
        <div className="statusQuestion">
            <div className="modal fade" id={`exampleModal${leadId}`} tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered" role="document">
                    {popupCheck === 1 ?
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title" id="exampleModalLabel">Send message</h5>
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>

                            <div className="modal-body">
                                <label>Hello</label>
                                <br />
                                <label>Just wanted to let you know that <strong> our Program Coordinator will be calling you </strong> within a few minutes to talk about <strong> {programName}</strong> that you signed up for <strong>{studentName}.</strong></label>
                                <br />
                                <label>Happy learning <br />
                            Lincoln Method Tutors</label>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-danger" data-dismiss="modal">Don't send</button>
                                <button type="button" className="btn btn-success" onClick={() => sendParentMessage(leadId, studentId, courseId)} >Send Now</button>
                            </div>
                        </div>

                        : popupCheck === 2 ?
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title" id="exampleModalLabel">Send Group Price</h5>
                                    <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>

                                <div className="modal-body">
                                    <img className="img-thumbnail" src="https://lincolnmethod.s3.amazonaws.com/group-price.jpg" />
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-danger" data-dismiss="modal">Don't send</button>
                                    <button type="button" className="btn btn-success" onClick={() => groupclassesImaggeSent(leadId, studentId, courseId)} >Send Now</button>
                                </div>
                            </div>
                            : popupCheck === 3 ?
                                <div className="modal-content">
                                    <div className="modal-header">
                                        <h5 className="modal-title" id="exampleModalLabel">Send 1 on 1 Price</h5>
                                        <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                            <span aria-hidden="true">&times;</span>
                                        </button>
                                    </div>

                                    <div className="modal-body">
                                        <img className="img-thumbnail" src="https://lincolnmethod.s3.amazonaws.com/one-on-one-price.jpg" />
                                    </div>
                                    <div className="modal-footer">
                                        <button type="button" className="btn btn-danger" data-dismiss="modal">Don't send</button>
                                        <button type="button" className="btn btn-success" onClick={() => oneOnOneclassesImaggeSent(leadId, studentId, courseId)} >Send Now</button>
                                    </div>
                                </div>
                                : popupCheck === 10 ?
                                    <div className="modal-content">
                                        <div className="modal-header">
                                            <h5 className="modal-title" id="exampleModalLabel">{videoTitle}</h5>
                                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                                <span aria-hidden="true">&times;</span>
                                            </button>
                                        </div>

                                        <div className="modal-body">
                                            <img className="img-thumbnail" src={videoLink} />
                                        </div>
                                        <div className="modal-footer">
                                            <button type="button" className="btn btn-danger" data-dismiss="modal">Don't send</button>
                                            <button type="button" className="btn btn-success" onClick={() => curriculumImageSend(leadId, studentId, courseId, videoLink, videoTitle)} >Send Now</button>
                                        </div>
                                    </div>
                                    : popupCheck === 4 ?
                                        <div className="modal-content">
                                            <div className="modal-header">
                                                <h5 className="modal-title" id="exampleModalLabel">Confirm</h5>
                                                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                                    <span aria-hidden="true">&times;</span>
                                                </button>
                                            </div>

                                            <div className="modal-body">
                                                {notInterested === 0 ?
                                                    <label>Mark this lead Not Intrested</label>
                                                    :
                                                    <label>Mark this lead Intrested</label>
                                                }
                                            </div>
                                            <div className="modal-footer">
                                                <button type="button" className="btn btn-danger" data-dismiss="modal">Cancel</button>
                                                {notInterested === 0 ?
                                                    <button type="button" className="btn btn-success" onClick={() => marknotIntrested(leadId, studentId, courseId, 1)} >Mark Not Intrested</button>
                                                    :
                                                    <button type="button" className="btn btn-success" onClick={() => marknotIntrested(leadId, studentId, courseId, 0)} >Mark Intrested</button>
                                                }
                                            </div>
                                        </div>
                                        : popupCheck === 5 ?
                                            <div className="modal-content">
                                                <div className="modal-header">
                                                    <h5 className="modal-title" id="exampleModalLabel">Confirm</h5>
                                                    <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                                        <span aria-hidden="true">&times;</span>
                                                    </button>
                                                </div>

                                                <div className="modal-body">
                                                    {spam === 0 ?
                                                        <label>Mark this lead Spammed</label>
                                                        :
                                                        <label>Mark this lead Not Spammed</label>
                                                    }
                                                </div>
                                                <div className="modal-footer">
                                                    <button type="button" className="btn btn-danger" data-dismiss="modal">Cancel</button>
                                                    {spam === 0 ?
                                                        <button type="button" className="btn btn-success" onClick={() => markSpammed(leadId, studentId, courseId, 1)} >Mark Spammed</button>
                                                        :
                                                        <button type="button" className="btn btn-success" onClick={() => markSpammed(leadId, studentId, courseId, 0)} >Mark Not Spammed</button>
                                                    }
                                                </div>
                                            </div>

                                            : popupCheck === 11 ?
                                                <div className="modal-content">
                                                    <div className="modal-header">
                                                        <h5 className="modal-title" id="exampleModalLabel">Confirm</h5>
                                                        <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                                            <span aria-hidden="true">&times;</span>
                                                        </button>
                                                    </div>

                                                    <div className="modal-body">
                                                        {noResponse === 0 ?
                                                            <label>Change status to No Response</label>
                                                            :
                                                            <label>Change status to Response Received</label>
                                                        }
                                                    </div>
                                                    <div className="modal-footer">
                                                        <button type="button" className="btn btn-danger" data-dismiss="modal">Cancel</button>
                                                        {noResponse === 0 ?
                                                            <button type="button" className="btn btn-success" onClick={() => markNoResponse(leadId, studentId, courseId, 1)} >No Response</button>
                                                            :
                                                            <button type="button" className="btn btn-success" onClick={() => markNoResponse(leadId, studentId, courseId, 0)} >Response Received</button>
                                                        }
                                                    </div>
                                                </div>

                                                : popupCheck === 12 ?
                                                    <div className="modal-content">
                                                        <div className="modal-header">
                                                            <h5 className="modal-title" id="exampleModalLabel">Confirm</h5>
                                                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                                                <span aria-hidden="true">&times;</span>
                                                            </button>
                                                        </div>

                                                        <div className="modal-body">
                                                            <label>Do you want to Cancel the Demo?</label>

                                                        </div>
                                                        <div className="modal-footer">
                                                            <button type="button" className="btn btn-danger" data-dismiss="modal">Cancel</button>
                                                            <button type="button" className="btn btn-success" onClick={() => cancelDemo(leadId, studentId, courseId, 1)} >Cancel Demo</button>

                                                        </div>
                                                    </div>

                                                    : popupCheck === 6 ?
                                                        <div className="modal-content">
                                                            <div className="modal-header">
                                                                <h5 className="modal-title" id="exampleModalLabel">Confirm</h5>
                                                                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                                                    <span aria-hidden="true">&times;</span>
                                                                </button>
                                                            </div>

                                                            <div className="modal-body">
                                                                Send Video to the parent
                                                </div>
                                                            <div className="modal-footer">
                                                                <button type="button" className="btn btn-danger" data-dismiss="modal">Cancel</button>
                                                                <button type="button" className="btn btn-success" onClick={() => videoTestimonialSend(leadId, studentId, courseId, videoLink, videoTitle)} >Send Video</button>

                                                            </div>
                                                        </div>
                                                        : popupCheck === 7 ?
                                                            <div className="modal-content">
                                                                <div className="modal-header">
                                                                    <h5 className="modal-title" id="exampleModalLabel">Send Image</h5>
                                                                    <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                                                        <span aria-hidden="true">&times;</span>
                                                                    </button>
                                                                </div>

                                                                <div className="modal-body">
                                                                    <img className="img-thumbnail" src={influenceImage} />
                                                                </div>
                                                                <div className="modal-footer">
                                                                    <button type="button" className="btn btn-danger" data-dismiss="modal">Don't send</button>
                                                                    <button type="button" className="btn btn-success" onClick={() => influenceImageSend(leadId, studentId, courseId, influenceImage)} >Send Now</button>
                                                                </div>
                                                            </div>
                                                            : popupCheck === 8 ?
                                                                <div className="modal-content">
                                                                    <div className="modal-header">
                                                                        <h5 className="modal-title" id="exampleModalLabel">Send {imageTitle} Image</h5>
                                                                        <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                                                            <span aria-hidden="true">&times;</span>
                                                                        </button>
                                                                    </div>

                                                                    <div className="modal-body">
                                                                        <img className="img-thumbnail" src={influenceImage} />
                                                                    </div>
                                                                    <div className="modal-footer">
                                                                        <button type="button" className="btn btn-danger" data-dismiss="modal">Don't send</button>
                                                                        <button type="button" className="btn btn-success" onClick={() => curriculumImageSend(leadId, studentId, courseId, influenceImage, imageTitle)} >Send Now</button>
                                                                    </div>
                                                                </div>
                                                                : popupCheck === 9 ?
                                                                    <div className="modal-content">
                                                                        <div className="modal-header">
                                                                            <h5 className="modal-title" id="exampleModalLabel">Send message</h5>
                                                                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                                                                <span aria-hidden="true">&times;</span>
                                                                            </button>
                                                                        </div>

                                                                        <div className="modal-body">
                                                                            <label>Hello</label>
                                                                            <br />
                                                                            <label>Just wanted to let you know that <strong> our Program Coordinator will be calling you </strong> within a few minutes to talk about <strong> {programName}</strong> that you signed up for <strong>{studentName}.</strong></label>
                                                                            <br />
                                                                            <label>Happy learning <br />
                                                Lincoln Method Tutors</label>
                                                                        </div>
                                                                        <div className="modal-footer">
                                                                            <button type="button" className="btn btn-danger" data-dismiss="modal">Don't send</button>
                                                                            <button type="button" className="btn btn-success" onClick={() => sendConversionMessage(leadId, studentId, courseId)} >Send Now</button>
                                                                        </div>
                                                                    </div>

                                                                    : null}

                </div>
            </div>
            <div className="callBox">
                <div className="row">
                    <div className="col-md-12 text-right mb-2">
                        {notInterested === 0 ?
                            <button className="spamCallBtn" data-toggle="modal" data-target={`#exampleModal${leadId}`} onClick={() => setpopupCheck(4)} >Not interested<i className="ml-2 fas fa-exclamation-circle"></i></button>
                            :
                            <button className="spamCallBtn" data-toggle="modal" data-target={`#exampleModal${leadId}`} onClick={() => setpopupCheck(4)} >Interested<i className="ml-2 fas fa-exclamation-circle"></i></button>
                        }
                        {spam === 0 ?
                            <button className="spamCallBtn" data-toggle="modal" data-target={`#exampleModal${leadId}`} onClick={() => setpopupCheck(5)}>Spam call<i className="ml-2 fas fa-skull-crossbones"></i></button>
                            :
                            <button className="spamCallBtn" data-toggle="modal" data-target={`#exampleModal${leadId}`} onClick={() => setpopupCheck(5)}>Not Spam<i className="ml-2 fas fa-skull-crossbones"></i></button>
                        }
                        {noResponse === 0 ?
                            <button className="spamCallBtn" data-toggle="modal" data-target={`#exampleModal${leadId}`} onClick={() => setpopupCheck(11)}>No response<i className="ml-2 fas fa-comment-slash"></i></button>
                            :
                            <button className="spamCallBtn" data-toggle="modal" data-target={`#exampleModal${leadId}`} onClick={() => setpopupCheck(11)}>Response received<i className="ml-2 fas fa-comment-slash"></i></button>
                        }
                        <button className="spamCallBtn" data-toggle="modal" data-target={`#exampleModal${leadId}`} onClick={() => setpopupCheck(12)}>Cancel Demo<i className="ml-2 fas fa-ban"></i></button>


                    </div>
                    <div className="col-md-4">
                        <label>Inform Parent you are about to call them</label>
                    </div>
                    <div className="col-md-8 text-left">
                        <button className="btn btn-dark btn-sm sendMessageBtn" data-toggle="modal" data-target={`#exampleModal${leadId}`} onClick={() => setpopupCheck(1)} >Send text and whatsapp message</button>
                        <div className="mt-2">
                            <label>Did the parent pick up?</label> <button className="yesBtn" onClick={() => callPickedUp(leadId, studentId, courseId)} >Yes</button> <button className="noBtn" onClick={() => callDontPickedUp(leadId, studentId, courseId)} >No</button>
                        </div>
                    </div>
                </div>
            </div>

            <div className="initialQuestion">
                <h5>About the Student</h5>
                <div className="row m-2">
                    <div className="col-md-6">
                        <div className="form-group">
                            <label for="exampleInputEmail1">Parent name:</label>
                            <input type="text" name="parentName" value={initialQuestionsData.parentName} onChange={(e) => onChangeInitialQuestionData(e)} className="form-control form-control-sm" id="exampleInputEmail1" aria-describedby="emailHelp" placeholder="" />
                        </div>
                        <div className="form-group">
                            <label for="exampleInputEmail1">Where do they live?</label>
                            <input type="text" name="whereLive" value={initialQuestionsData.whereLive} onChange={(e) => onChangeInitialQuestionData(e)} className="form-control form-control-sm" id="exampleInputEmail1" aria-describedby="emailHelp" placeholder="" />
                        </div>
                        <div className="form-group">
                            <label for="exampleInputEmail1">School Name:</label>
                            <input type="text" name="schoolName" value={initialQuestionsData.schoolName} onChange={(e) => onChangeInitialQuestionData(e)} className="form-control form-control-sm" id="exampleInputEmail1" aria-describedby="emailHelp" placeholder="" />
                        </div>
                    </div>
                    <div className="col-md-12">
                        <div className="form-group">
                            <label for="exampleInputEmail1">What are the objectives of the free demo class?</label>
                            {initialQuestionsData.challengesFace && initialQuestionsData.challengesFace.map((item, index) =>
                                <div className="form-check" key={index}>
                                    <input className="form-check-input" type="checkbox" name={`intrested${leadId}`} checked={item.checked} value="Group classes" onChange={() => onChangeInitialQuestionDataChallenges(item.id)} />
                                    <label className="form-check-label" for="inlineRadio1">{item.title}</label>
                                    {/* <div className="col-md-6">
                                        <div class="form-group">
                                            <label for="exampleFormControlTextarea1">Notes to tutor:</label>
                                            <textarea className="form-control" name="notesToTutor" className="form-control form-control-sm" id="exampleFormControlTextarea1" rows="4"></textarea>
                                        </div>
                                    </div> */}
                                </div>
                            )}
                            {/* <div className="form-check">
                                <input className="form-check-input" type="radio" name={`2${leadId}`} checked={"Advance learning" == initialQuestionsData.challengesFace} value="Advance learning" onChange={(e) => onChangeInitialQuestionDataChallenges(e)} />
                                <label className="form-check-label">Advance Learning</label>
                            </div>
                            <div className="form-check">
                                <input className="form-check-input" type="radio" name={`3${leadId}`} checked={"Homework help" == initialQuestionsData.challengesFace} value="Homework help" onChange={(e) => onChangeInitialQuestionDataChallenges(e)} />
                                <label className="form-check-label" >Homework help</label>
                            </div>
                            <div className="form-check">
                                <input className="form-check-input" type="radio" name={`4${leadId}`} checked={"Exam prep" == initialQuestionsData.challengesFace} value="Exam prep" onChange={(e) => onChangeInitialQuestionDataChallenges(e)} />
                                <label className="form-check-label">Exam prep</label>
                            </div> */}
                        </div>

                        <div className="form-group">
                            <label for="exampleInputEmail1">What tutoring option are you intrested in?</label>
                            {initialQuestionsData.tutoringOption && initialQuestionsData.tutoringOption.map((item, index) =>
                                <div className="form-check" key={index}>
                                    <input className="form-check-input" type="checkbox" name={`intrested${leadId}`} checked={item.checked} value="Group classes" onChange={() => onChangeInitialQuestionDataIntrested(item.id)} />
                                    <label className="form-check-label" for="inlineRadio1">{item.title}</label>
                                </div>
                            )}
                            {/* <div className="form-check">
                                <input className="form-check-input" type="radio" name={`intrested${leadId}`} checked={"1 on 1 classes" == initialQuestionsData.tutoringOption} value="1 on 1 classes" onChange={(e) => onChangeInitialQuestionDataIntrested(e)} />
                                <label className="form-check-label" for="inlineRadio2">1 on 1 classes</label>
                            </div>
                            <div className="form-check">
                                <input className="form-check-input" type="radio" name="tutoringOption" name={`intrested${leadId}`} checked={"Exam prep classes" == initialQuestionsData.tutoringOption} value="Exam prep classes" onChange={(e) => onChangeInitialQuestionDataIntrested(e)} />
                                <label className="form-check-label" for="inlineRadio2">Exam prep classes</label>
                            </div> */}
                        </div>
                    </div>
                </div>
                <div className="row m-2">
                    <div className="col-md-6">
                        <div class="form-group">
                            <label for="exampleFormControlTextarea1">Notes:</label>
                            <textarea className="form-control form-control-sm" name="notes" value={initialQuestionsData.notes} onChange={(e) => onChangeInitialQuestionData(e)} id="exampleFormControlTextarea1" rows="4"></textarea>
                        </div>
                    </div>
                </div>
                <div className="row m-2">
                    <div className="col-md-12">
                        <div className="text-right">
                            <button className="btn btn-sm sendMessageBtn" onClick={() => submitPersonalData(leadId)} >Submit</button>
                        </div>
                    </div>
                </div>

                <hr />
                <h5>Pricing</h5>
                <div className="row m-2">
                    <div className="col-md-6">
                        <div className="d-flex justify-content-between">
                            <label>Bundle Package for Group classes</label>
                            <button className="sendImageBtn" data-toggle="modal" data-target={`#exampleModal${leadId}`} onClick={() => setpopupCheck(2)} >See Image</button>
                        </div>
                        <div className="d-flex justify-content-between mt-1">
                            <label>1 on 1 classes</label>
                            <button className="sendImageBtn" data-toggle="modal" data-target={`#exampleModal${leadId}`} onClick={() => setpopupCheck(3)} >See Image</button>
                        </div>
                        <div className="d-flex justify-content-between mt-1">
                            <label>KGS Admission Prep</label>
                            <button className="sendImageBtn" data-toggle="modal" data-target={`#exampleModal${leadId}`} onClick={() => openVideoModal(10, "https://lincolnmethod.s3.amazonaws.com/KGS+addimsion+Price.jpg", "KGS Admission Prep")} >See Image</button>
                        </div>
                        <div className="d-flex justify-content-between mt-1">
                            <label>Siblings Discount</label>
                            <button className="sendImageBtn" data-toggle="modal" data-target={`#exampleModal${leadId}`} onClick={() => openVideoModal(10, "https://lincolnmethod.s3.amazonaws.com/Siblings+Discount.jpg", "Siblings Discount")} >See Image</button>
                        </div>
                        <div className="d-flex justify-content-between mt-1">
                            <label>Study Buddy Program</label>
                            <button className="sendImageBtn" data-toggle="modal" data-target={`#exampleModal${leadId}`} onClick={() => openVideoModal(10, "https://lincolnmethod.s3.amazonaws.com/Study+Buddy.jpg", "Study Buddy Program")} >See Image</button>
                        </div>
                        <div className="d-flex justify-content-between mt-1">
                            <label>Ramadan Offer</label>
                            <button className="sendImageBtn" data-toggle="modal" data-target={`#exampleModal${leadId}`} onClick={() => openVideoModal(10, "https://lincolnmethod.s3.amazonaws.com/Ramadan+Offer.png", "Ramadan Offer")} >See Image</button>
                            {historyData && historyData.data.some(person => person.video_name === "Ramadan Offer") ? <i className="fas fa-check sendFound"></i> : null}
                        </div>
                    </div>
                </div>
                <h5 className="mt-5">Video Testimonials </h5>
                <div className="row m-2">
                    <div className="col-md-6">
                        {videosList.map((item, index) =>
                            <div>
                                <div className="d-flex justify-content-between">
                                    <ModalVideo channel='custom' url={item.videoId} isOpen={item.isOpen === true} onClose={() => openVideo(item.id)} />
                                    <div>
                                        <label>{index + 1}.  {item.title}</label>
                                    </div>
                                    <div>
                                        <button onClick={() => openVideo(item.id)} className="play-button"><i className="fas fa-play"></i> Play</button>
                                        <button className="sendImageBtn" data-toggle="modal" data-target={`#exampleModal${leadId}`} onClick={() => openVideoModal(6, item.videoId, item.title)} >Send Video</button>
                                    </div>
                                    {historyData && historyData.data.some(person => person.video_name === item.title) ? <i className="fas fa-check sendFound"></i> : null}
                                </div>
                            </div>
                        )}
                    </div>
                </div>

                <h5 className="mt-5">The Influencer </h5>
                <div className="row m-2">
                    <div className="col-md-6">
                        <div className="d-flex justify-content-between">
                            <label>Free Upgrade to Premium</label>
                            <button className="sendImageBtn mt-1" data-toggle="modal" data-target={`#exampleModal${leadId}`} onClick={() => openInfluenceModal(7, "https://lincolnmethod.s3.amazonaws.com/influencer/upgrade-to-premium.jpg")} >See Image</button>
                        </div>
                        <div className="d-flex justify-content-between">
                            <label>Good Luck in your Exams</label>
                            <button className="sendImageBtn mt-1" data-toggle="modal" data-target={`#exampleModal${leadId}`} onClick={() => openInfluenceModal(7, "https://lincolnmethod.s3.amazonaws.com/influencer/good-luck-exams.jpg")} >See Image</button>
                        </div>
                        {/* <div className="d-flex justify-content-between">
                            <label>Curriculum</label>
                            <button className="sendImageBtn" data-toggle="modal" data-target={`#exampleModal${leadId}`} onClick={() => openInfluenceModal(8, curriculum_img)} >See Image</button>
                        </div> */}
                        {historyData.curriculumFOMO && historyData.curriculumFOMO.map((item, index) =>
                            <div className="d-flex justify-content-between">
                                <label>{item.image_title}</label>
                                <button className="sendImageBtn mt-1" data-toggle="modal" data-target={`#exampleModal${leadId}`} onClick={() => openInfluenceModal(8, item.imageurl, item.image_title)} >See Image</button>
                                {historyData && historyData.data.some(person => person.video_name === item.image_title) ? <i className="fas fa-check sendFound"></i> : null}
                            </div>
                        )}
                        <div className="d-flex justify-content-between">
                            <label>About this course (Text Message)</label>
                            <button className="sendImageBtn mt-1" onClick={() => aboutThisCourse(leadId, studentId, courseId)} >Send Message</button>
                        </div>
                    </div>
                </div>

                <hr />

                <h5 className="mt-5">Conversion Call</h5>
                <div className="callBox">
                    <div className="row">
                        <div className="col-md-4">
                            <label>Inform Parent you are about to call them for conversion</label>
                        </div>
                        <div className="col-md-8 text-left">
                            <button className="btn btn-dark btn-sm sendMessageBtn" data-toggle="modal" data-target={`#exampleModal${leadId}`} onClick={() => setpopupCheck(9)}>Send text and whatsapp message</button>
                            <div className="mt-2">
                                <label>Did the parent pick up?</label> <button className="yesBtn" onClick={() => callPickedUp(leadId, studentId, courseId)} >Yes</button> <button className="noBtn" onClick={() => callDontPickedUp(leadId, studentId, courseId)} >No</button>
                            </div>
                        </div>
                    </div>
                </div>

                <h5 className="mt-5">Excuses for not converting</h5>
                <div className="row m-2">
                    <div className="col-md-6">
                        <div className="form-group">
                            <label for="exampleInputEmail1">Reasons why the client does not want to continue</label>

                            {notConvertingQuestion.map((item, index) =>
                                <div className="form-check" key={index}>
                                    <input className="form-check-input" type="checkbox" name={`intrested${leadId}`} checked={item.checked} value="Scheduling conflict" onChange={() => onChangeNotConvertingQuestion(item.id)} />
                                    <label className="form-check-label"> {item.title} </label>
                                </div>
                            )}

                            {/* <div className="form-check">
                                <input className="form-check-input" type="checkbox" name={`intrested${leadId}`} value="Pricing" />
                                <label className="form-check-label"> Pricing </label>
                            </div>

                            <div className="form-check">
                                <input className="form-check-input" type="checkbox" name={`intrested${leadId}`} value="Too burdensome for my child" />
                                <label className="form-check-label"> Too burdensome for my child </label>
                            </div>
                            <div className="form-check">
                                <input className="form-check-input" type="checkbox" name={`intrested${leadId}`} value="Payment mechanism" />
                                <label className="form-check-label"> Payment mechanism</label>
                            </div>
                            <div className="form-check">
                                <input className="form-check-input" type="checkbox" name={`intrested${leadId}`} value="I didn't like the teacher" />
                                <label className="form-check-label"> I didn't like the teacher</label>
                            </div>
                            <div className="form-check">
                                <input className="form-check-input" type="checkbox" name={`intrested${leadId}`} value="I didn't like the teacher" />
                                <label className="form-check-label">Not now, maybe later</label>
                            </div> */}
                        </div>
                    </div>
                </div>
                <div className="row m-2">
                    <div className="col-md-12">
                        <div className="text-right">
                            <button className="btn btn-sm sendMessageBtn" onClick={() => submitPersonalData(leadId)} >Submit</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default connect(null, {
    getLeadData
})(StatusQuestion);